import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  containedButton: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    width: "auto",
    borderRadius: `10px !important`,
    fontSize: "14px",
    padding: "10px 20px !important",
    color: `${theme.palette.text.secondary} !important`,
    textTransform: `none !important`,
    "&:hover": {
      backgroundColor: `${theme.palette.secondary.dark} !important`,
    },
  },
  outlineButton: {
    borderColor: `${theme.palette.secondary.main} !important`,
    color: `${theme.palette.secondary.main} !important`,
    borderRadius: `10px !important`,
    textTransform: `none !important`,
    padding: "10px 20px !important",
    "&:hover": {
      borderColor: `${theme.palette.secondary.dark} !important`,
    },
  },
  tableContainer: {
    flex: 1,
    overflow: "hidden",
  },
  headerCell: {
    background: "#252A384D !important",
    color: "#F9F9F9 !important",
    border: `1px solid ${theme.palette.secondary.light} !important`,
  },
  tableCell: {
    color: `#f9f9f9 !important`,
    border: `1px solid ${theme.palette.secondary.light} !important`,
  },
  lightText: {
    color: `#B1B5C9 !important`,
    marginLeft: "4px",
  },
}));

export default useStyles;
